/**
 * The public legal pages are static files served by the public site (`wwwroot/pages` of the
 * API, which also serves mesterplan.dk), not routes of this app. The Sidebar and the app link
 * to the same host. The DPA PDF is an API endpoint, so it follows VITE_MESTERPLAN_API_URL.
 */
const PUBLIC_SITE = 'https://mesterplan.dk';
const apiBase = (import.meta.env.VITE_MESTERPLAN_API_URL ?? '').replace(/\/+$/, '');

export const TERMS_URL = `${PUBLIC_SITE}/pages/terms.html`;
/** The public GDPR page, with the sub-processor table. */
export const GDPR_URL = `${PUBLIC_SITE}/pages/gdpr.html`;
/** The current DPA as a PDF, anonymous. */
export const DPA_PDF_URL = `${apiBase}/api/legal/dpa/current/pdf`;
